module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Cardápio")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cadastro comum para")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('recipients-group', {
    attrs: {
      "label": 'Selecione a configuração do cardápio'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.recipientGroup === 'PER_LEVEL') ? _c('class-level', {
    attrs: {
      "label": 'Selecione o nível de ensino',
      "blacklist": ['Fundamental_2', 'EnsinoMedio']
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_GRADE') ? _c('class-grade', {
    attrs: {
      "label": 'Selecione o ano de ensino'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_CLASS') ? _c('school-class', {
    attrs: {
      "label": 'Selecione a turma',
      "group": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.recipientGroup) ? _c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para qual semana será criado o cardápio?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('year', {
    attrs: {
      "label": 'Ano letivo',
      "group": false,
      "with-next-year": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('month', {
    attrs: {
      "disabled": !_vm.year,
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('week', {
    attrs: {
      "disabled": !_vm.year || !_vm.month || (_vm.month && _vm.month.index === -1),
      "group": false
    }
  })], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mealMenu && _vm.mealMenu.length),
      expression: "mealMenu && mealMenu.length"
    }],
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Os cardápio respeitam a seguinte ordem: Turma > Ano de Ensino > Nível de Ensino > Toda escola.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-block purple",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.duplicate
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Duplicar")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-block yellow-gold",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.showMonthly
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Visão mensal")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "m-t-5 m-b-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [(_vm.isEditMode) ? _c('a', {
    staticClass: "btn red-mint",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.editMode(false)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cancelar")])]) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('a', {
    staticClass: "btn blue",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.editMode
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.mealMenu && _vm.mealMenu.length) ? _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-layout-fixed"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-yellow-gold font-white"
  }, _vm._l((_vm.mealMenu), function(item, $index) {
    return _c('th', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "display-block"
    }, [_vm._v(_vm._s(_vm._f("date")(item.date, 'dddd')))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("date")(item.date, 'DD/MM/YYYY')))]), _vm._v(" "), _c('tooltip', {
      attrs: {
        "popper-class": "font-green-jungle",
        "content": "Cardápio disponível na agenda do aluno",
        "placement": "bottom"
      }
    }, [(item.id) ? _c('button', {
      staticClass: "btn btn-xs yellow-gold pull-left",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-check-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])], 1)
  })), _vm._v(" "), (_vm.isEditMode) ? _c('tr', _vm._l((_vm.mealMenu), function(item, $index) {
    return _c('th', [(item.id) ? _c('button', {
      staticClass: "btn btn-xs btn-block red-flamingo",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeMealDay(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRemover cardápio\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('td', [_vm._l((item.times), function(meal, index) {
      return _c('div', {
        attrs: {
          "role": "form"
        }
      }, [_c('div', {
        staticClass: "well p-5"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Refeição")])]), _vm._v(" "), (_vm.isEditMode) ? _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.type),
          expression: "meal.type"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "name": "meal-type",
          "disabled": item.isBefore
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(meal, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }],
        attrs: {
          "value": "",
          "selected": ""
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.ENUM.MealTimeType), function(value, index) {
        return _c('option', {
          domProps: {
            "value": index
          }
        }, [_vm._v(_vm._s(value))])
      })], 2) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(_vm._f("enum")(meal.type, 'MealTimeType') || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Horário")])]), _vm._v(" "), (_vm.isEditMode) ? _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('##:##'),
          expression: "'##:##'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (meal.time),
          expression: "meal.time"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ({
            rules: {
              required: true,
              regex: /([01]\d|2[0-3]):([0-5]\d)/
            }
          }),
          expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-time",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "time", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(meal.time || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Alimento")])]), _vm._v(" "), (_vm.isEditMode) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.meal),
          expression: "meal.meal"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-meal",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.meal)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "meal", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(meal.meal || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Bebida e/ou fruta")])]), _vm._v(" "), (_vm.isEditMode) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.beverage),
          expression: "meal.beverage"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-beverage",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.beverage)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "beverage", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(meal.beverage || '-'))]) : _vm._e()]), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
        staticClass: "form-group m-b-0"
      }, [_c('button', {
        staticClass: "btn btn-sm btn-block red-mint",
        attrs: {
          "type": "button",
          "disabled": item.isBefore
        },
        on: {
          "click": function($event) {
            _vm.removeItem($index, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Remover refeição")])])]) : _vm._e()])])
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isEditMode && !item.isBefore),
        expression: "isEditMode && !item.isBefore"
      }],
      staticClass: "form-group m-b-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-block yellow-gold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addItem($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Adicionar refeição")])])])], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-md-offset-9"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [(_vm.isEditMode) ? _c('a', {
    staticClass: "btn red-mint",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.editMode(false)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cancelar")])]) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('a', {
    staticClass: "btn blue",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.editMode
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])]) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tCardápios de datas passadas não podem ser editados.\n\t\t\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84c2ab10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/meal-menu/main.vue
// module id = 1095
// module chunks = 1